import { AnalyticsEvents } from './analyticsEvents.enum'

export enum LayoutTypes {
  MWEB_LAYOUT = 'mweb',
  WEB_LAYOUT = 'web',
}

export type PageViewedEventProperties = {
  entry_id: string
  /** The page's language (en-CA / fr-CA), added by the hook. */
  page_locale?: string
  /** The language saved with the header toggle, or null if the visitor never used it. */
  preferred_locale?: string | null
}

export type LinkClickedEventProperties = {
  entry_id: string
  contentful_type: string
  link_to: string
  link_text: string
  header_version?: string
  position?: string
  /** The page's language (en-CA / fr-CA), added by the hook. */
  page_locale?: string
}

export type NavigationOpenedEventProperties = {
  entry_id: string
  contentful_type: string
  link_text: string
  header_version?: string
  position?: string
}

export type ButtonClickedEventProperties = {
  entry_id: string
  contentful_type: string
  button_text: string
}

export type AnalyticsEventProperties =
  | PageViewedEventProperties
  | LinkClickedEventProperties
  | ButtonClickedEventProperties

export type GTMEventProperties<TProperties extends AnalyticsEventProperties> = TProperties & { event: AnalyticsEvents }
